import Case from "case";
import { derived } from "svelte/store";
import { languageStore } from "../stores/language";

export const getNamedLanguages = (isoCodes: string[]) => {
  return isoCodes.reduce<string[]>((acc, code) => getLanguageNativeName(code) ? [...acc, code] : acc, []);
};

export const getLanguageNativeName = (isoCode: string) => {
  const nativeName = new Intl.DisplayNames([isoCode], { type: "language" }).of(isoCode);
  return nativeName && nativeName !== isoCode ? Case.capital(nativeName) : undefined;
};

export const getSelectedLanguageName = (selectedIsoCode: string, availableIsoCode: string[]) => {
  return getLanguageNativeName(availableIsoCode.find((code) => code === selectedIsoCode) || "en");
};

export const getRegionNativeName = derived([languageStore], ([$language]) => (isoCode: string) => {
  return new Intl.DisplayNames([$language], { type: "region" }).of(isoCode);
});
